<template lang="html">
  <v-dialog
  v-model="dialog"
  width="500"
  >
  <template v-slot:activator="{ on }">
    <v-btn
    style="float:right"
    color="primary"
    dark
    v-on="on"
    >
    Anmelden
  </v-btn>
</template>

<v-toolbar class="pt-5 blue darken-4">
  <v-toolbar-title class="white--text"><h4>Anmelden</h4></v-toolbar-title>
</v-toolbar-items>
</v-toolbar>
<v-card>
  <v-card-text class="pt-4">
    <div>
      <v-form v-model="valid" ref="form">
        <v-text-field
        label="E-mail"
        v-model="assignee.email"
        ></v-text-field>

        <v-text-field
        label="Name"
        v-model="assignee.name"
        ></v-text-field>

        <v-text-field
        :label="lang.monogram"
        v-model="assignee.monogram"
        required
        ></v-text-field>
        <div v-if="assignee.monogram == '' && showErrors" style="color:red">
          {{ lang.kotelezoen_kitoltendo_mezo }}
        </div>
        <div>{{response}}</div>
        <v-layout justify-space-between>
          <v-btn @click="submit" >Go</v-btn>
        </v-layout>
      </v-form>
    </div>
  </v-card-text>
</v-card>
</v-dialog>
</template>

<script>
import axios from 'axios';
const ASSIGNEE = {
  email: '',
  name: '',
  monogram: ''
}
   export default {
     data(){
       return {
         assignee: { ...ASSIGNEE },
         dialog: false,
         valid: false,
         showErrors: false,
         response: '',
         e1: 1,
       }
     },
     methods: {
       async submit () {
         this.showErrors = true
         if (this.assignee.monogram == '') return
         axios.post('assignees/create.php', this.assignee)
         .then(response => {
           this.showErrors = false
           if (response.data.success) {
             this.response = this.lang.muvelet_sikeresen_vegrehajtva
             this.assignee = { ...ASSIGNEE }
             setTimeout(function(){
               this.dialog = false
               this.$emit('itemCreated')
             }.bind(this), 500);
           } else {
             this.response = this.lang.hiba_tortent_a_muvelet_vegrehajtasa_soran
           }
         })
         .catch(e => {
           this.response = this.lang.hiba_tortent_a_muvelet_vegrehajtasa_soran
         })
       }
     },
     watch: {
       dialog(val){
           if (!val) {
             this.assignee = { ...ASSIGNEE }
           }
       }
     }
   }
 </script>
